angular.module('mx.components').component('mxFormMessage', {
	controller: MxFormMessageCtrl,
	controllerAs: 'vm',
	require: { form: '?^form' },

	bindings: {
		active: '<',
		message: '@',
		type: '@',
		actionButtonLabel: '@',
		assignButtonTo: '=',
		assignButtonFrom: '=',
		actionButtonClick: '&',
	},
});

MxFormMessageCtrl.$inject = ['$scope', '$timeout'];

function MxFormMessageCtrl($scope, $timeout) {
	const vm = this;
	let actionButton;
	let errorMessage;

	vm.initFormErrors = initFormErrors;

	vm.$onInit = function () {
		actionButton = vm.actionButtonLabel
			? {
					clickHandler: function () {
						if (angular.isFunction(vm.actionButtonClick)) {
							vm.actionButtonClick();
						}
						vm.assignButtonTo = vm.assignButtonFrom;
					},
					label: vm.actionButtonLabel,
			  }
			: null;

		errorMessage = new mx.components.Forms.ErrorMessage(vm.message, vm.active, vm.type, actionButton);
		setActive(vm.active);
	};

	vm.$onChanges = function (changes) {
		if (errorMessage) {
			if (changes.message && changes.message.currentValue !== errorMessage.message) {
				errorMessage.message = changes.message.currentValue;
			}
			if (changes.active) {
				setActive(changes.active.currentValue);
			}
		}
	};

	vm.$postLink = function () {
		if (vm.form) {
			initFormErrors(vm.form);
		}
	};

	vm.$onDestroy = function () {
		setActive(false);
	};

	function setActive(val) {
		errorMessage.isActive = Boolean(val);
	}

	function initFormErrors(formController) {
		$timeout(function () {
			if (typeof formController.addFormErrorMessage === 'function') {
				formController.addFormErrorMessage(errorMessage);
			}
		});
	}
}
